<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>

          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              {{ formData.productionDate || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item prop="storageType" label="出入库类型">
              {{ storageTypeMap.get(formData.storageType) || '' }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="storageDate" label="出入库日期">
              {{ formData.storageDate || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号/罐号">
              {{ formData.plateNumber || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inventoryId" label="出入库工单">
              {{ formData.inventoryId || '' }}
              <!-- <span class="detail" v-if="formData.inventoryId">工单详情</span> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="testResult" label="质检结果">
              <el-tag type="success" v-if="formData.testResult == '1'">合格</el-tag>
              <el-tag type="danger" v-if="formData.testResult == '2'">不合格</el-tag>

            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="inspectorName" label="质检员">
             {{ formData.inspectorName||'' }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="goodsName" label="原料供应商">
              {{ formData.goodsName || '' }}

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
import { storageType } from '@/utils/dict'

export default {
  name: 'QualityControlReportDetail',
  data() {
    return {
      storageTypeMap: storageType,
      formData: {
        productionDate: '',
        storageType: '',
        storageDate: '',
        specId: '',
        plateNumber: '',
        inventoryId: '',
        testResult: '',
        inspector: '',
        fileList: []
      },

      loading: false

    }
  },
  created() {
    if (this.reportId) {
      this.loadData()
    }
  },
  computed: {
    reportId() {
      return this.$route.query.reportId
    },
    fileImgUrl() {
      const arr = this.formData.fileList.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.qualityControlReport.selectPaQcReportByReportId, {
          params: { reportId: this.reportId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-input,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.detail {
  cursor: pointer;
  color: $color-primary;
  text-decoration: underline;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.table-form {
  .table-form-item {
    padding: 10px 0;

    ::v-deep .el-form-item__content {
      .el-form-item__error {
        transform: translateY(-10px);
      }
    }

  }

}
</style>
